export default __webpack_public_path__ + "static/media/dashboard.179932af.png";